import Animation from './Animation';
import { play } from '../../../SoundManager';

export default class Drink extends Animation {

	constructor (master) {

		super(master, 0);
		this.loadAudio("drink");
	}

	run () {

	}
}